import { StarIcon } from '@heroicons/react/24/solid';
import { useTranslation } from '../hooks/useTranslation';
import Button from './Button';
import { Link } from 'react-router-dom';

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="pt-28 pb-20 px-4 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-600 px-4 py-1 rounded-full text-sm mb-4">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-500"></span>
            </span>
            {t('heroTagline')}
          </div>
          <h1 className="text-4xl lg:text-6xl font-bold leading-tight mb-6">
            {t('heroTitle')}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
            {t('heroDescription')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <Link to="/access">
              <Button size="lg" className="bg-teal-500 hover:bg-teal-600">
                {t('startFreeTrial')}
              </Button>
            </Link>
            <a
              href="https://cal.com/appointdoc/30min"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button size="lg" variant="ghost">
                {t('scheduleDemo')}
              </Button>
            </a>
          </div>
          <div className="flex flex-col items-center gap-4">
            <div className="flex -space-x-2">
              {[...Array(5)].map((_, i) => (
                <div
                  key={i}
                  className="w-8 h-8 rounded-full border-2 border-white bg-gray-200"
                />
              ))}
            </div>
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <StarIcon
                    key={i}
                    className="w-4 h-4 text-yellow-400 fill-current"
                  />
                ))}
              </div>
              <p className="text-sm text-gray-600">{t('trustedBy')}</p>
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-600">
              <span>•</span>
              <span>{t('noCreditCard')}</span>
              <span>•</span>
              <span>{t('cancelAnytime')}</span>
              <span>•</span>
              <span>{t('hipaaCompliant')}</span>
            </div>
          </div>
        </div>
        <div className="relative mt-16">
          <div className="absolute inset-0 bg-gradient-to-t from-white to-transparent z-10 h-8 bottom-0"></div>
          <div className="bg-gradient-to-b from-gray-100 to-white rounded-xl overflow-hidden shadow-2xl">
            <img
              src="/placeholder.svg?height=600&width=1200"
              alt={t('heroTitle')}
              width={1200}
              height={600}
              className="w-full"
              priority="true"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
